var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fluid-container text-center"},[_c('div',{staticClass:"alert",class:{ 'alert-success': _vm.type === 'success', 'alert-danger': _vm.type === 'error'},attrs:{"role":"alert"}},[_c('div',{staticClass:"flash-status"},[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }